export default "__VITE_ASSET__f4e44395__"